import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconHandStop,
  IconFilter,
  IconSearch,
  IconDownload,
  IconCalendar,
  IconTrash,
  IconDotsVertical,
  IconPlus,
  IconSettings,
  IconEdit,
  IconWritingSign,
  IconActivity,
  IconUsers,
  IconUsersGroup,
  IconPencilUp,
  IconClock,
  IconView360,
  IconEye,
  IconSend,
  IconEyeCheck,
  IconViewfinder,
  IconFileAnalytics,
  IconFileArrowRight,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Menu,
  rem,
  ScrollArea,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
  Collapse,
} from "@mantine/core";
import ProcessInstancesModel from "../../model/ProcessInstancesModel";
import { DatePickerInput } from "@mantine/dates";
import {
  getEcmClassSelect,
  getOrganizationsSelect,
  getPartnersSelect,
  getProcessDefSelect,
  getUsersSelect,
} from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import PopupStep from "../History/PopupStep";
import { modals } from "@mantine/modals";
import { FoldersModel } from "../../model/_baseId";
import { CreateProfile } from "./CreateProfile/CreateProfile";
import { BASE_API_MASTER, BASE_API_SIGN } from "../../_base/_const";
import {
  pageTable,
  repositorySign,
  styleTable,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import DeleteTableView from "./CreateProfile/DeleteTableView/DeleteTableView";
import { IconSquareXFilled } from "@tabler/icons-react";
import { IconFile } from "@tabler/icons-react";
import { IconBrandRedux } from "@tabler/icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { downloadFileWithLoading } from "../../_base/helper/DownloadHelper";
import { useForm } from "@mantine/form";
import { EditProfile } from "./CreateProfile/EditProfile/EditProfile";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { FileReturnModel } from "../../model/FileReturnModel";
import { get } from "https";
import saveAs from "file-saver";
import HistoryProfile from "./CreateProfile/HistoryProfile/HistoryProfile";
import { PdfFileView } from "../Flow-step/PdfFileView";
import { IconEyeCode } from "@tabler/icons-react";
import { randomId } from "@mantine/hooks";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
import { IconMessageCircle } from "@tabler/icons-react";
import CommentModal from "./CommentModal/CommentModal";
import { useViewportSize } from "@mantine/hooks";
import { AttachmentEditModal } from "./AttachmentEditModal/AttachmentEditModal";

// Search history utility functions
const SEARCH_HISTORY_KEY = "folders_search_criteria";

interface SearchCriteria {
  keySearch: string;
  EmployeeId: string;
  PartnerId: string;
  DepartmentId: string;
  Status: string;
  DoctypeId: string;
}

const saveSearchCriteria = (criteria: SearchCriteria) => {
  try {
    const hasSearchCriteria = Object.values(criteria).some(
      (value) => value && value.toString().trim() !== ""
    );

    if (hasSearchCriteria) {
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(criteria));
    }
  } catch (error) {
    console.error("Error saving search criteria:", error);
  }
};

const getSearchCriteria = (): SearchCriteria | null => {
  try {
    const savedCriteria = localStorage.getItem(SEARCH_HISTORY_KEY);
    return savedCriteria ? JSON.parse(savedCriteria) : null;
  } catch (error) {
    console.error("Error reading search criteria:", error);
    return null;
  }
};

const clearSearchCriteria = () => {
  try {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  } catch (error) {
    console.error("Error clearing search criteria:", error);
  }
};

interface DocumentRecord {
  id: number | null;
  code: string | null;
  name: string | null;
  active: boolean | null;
  doctypeId: number | null;
  relateRecordsId: string | null;
  description: string | null;
  signedDocument: string | null;
  attachments: string | null;
  expirationDate: string | null;
  partnerId: number | null;
  departmentId: number | null;
  employeeId: number | null;
  createDate: string | null;
  createBy: number | null;
  lastUpdateDate: string | null;
  lastUpdateBy: number | null;
  startDate: string | null;
  signedDate: string | null;
  warningExpired: string | null;
  isSignature: boolean | null;
  stepCurrent: number | null;
  stepTotal: number | null;
  isSuccess: boolean | null;
  lastUpdateName: string | null;
  createName: string | null;
  doctypeName: string | null;
  isIgore: boolean | null;
  steupId: number | null;
  createByName: string | null;
  empByName: string | null;
  partnerName: string | null;
  employeName: string | null;
  departmentName: string | null;
  status: string | null;
  stepNumber: string | null;
}

const FoldersTable = () => {
  //#region  table
  //data and fetching state
  const [data, setData] = useState<DocumentRecord[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchParams] = useSearchParams();
  const [filterOpen, setFilterOpen] = useState(false);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);
  const [listVendor, setListVendor] = useState<SelectListItem[]>([]);
  const [listDocType, setListDocType] = useState<SelectListItem[]>([]);
  const [listDocument, setListDocument] = useState<SelectListItem[]>([]);

  const [listEmployee, setListEmployee] = useState<SelectListItem[]>([]);
  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);

  // Add attachment modal state
  const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
  const [selectedDocumentForAttachment, setSelectedDocumentForAttachment] =
    useState<{
      id: number;
      attachments: string;
    } | null>(null);

  const navigate = useNavigate();
  const _span = { base: 4, md: 3, lg: 2 };
  const [search, setSearch] = useState({
    keySearch: "",
    EmployeeId: "",
    PartnerId: "",
    DepartmentId: "",
    customerId: "",
    startDate: "",
    endDate: "",
    codefund: "",
    accountfund: "",
    deartment: "",
    branch: "",
    type: "",
    workplace: "",
    creator: "",
    Type: 0,
    Status: "",
    DoctypeId: "",
  });

  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  // Function to handle search and save criteria
  const handleSearch = async () => {
    const currentFilters = form.getValues();

    // Save current search criteria to localStorage
    saveSearchCriteria({
      keySearch: currentFilters.keySearch,
      EmployeeId: currentFilters.EmployeeId,
      PartnerId: currentFilters.PartnerId,
      DepartmentId: currentFilters.DepartmentId,
      Status: currentFilters.Status,
      DoctypeId: currentFilters.DoctypeId,
    });

    // Perform search
    await fetchData();
  };

  // Function to clear search and history
  const handleClearSearch = () => {
    form.reset();
    clearSearchCriteria();
    fetchData();
  };

  function getUrlSearchExport() {
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    const queryParams = {
      Skip: pagination.pageIndex * pagination.pageSize,
      Take: pagination.pageSize,
      EmployeeId: form.getValues().EmployeeId,
      PartnerId: form.getValues().PartnerId,
      DepartmentId: form.getValues().DepartmentId,
      CustomerId: form.getValues().customerId,
      KeySearch:
        form.getValues().keySearch.toLowerCase() ||
        form.getValues().keySearch.toLowerCase(),
      sort: _softing,
      isOrder: sorting.length > 0 ? sorting[0].desc : true,
      EmpId: localStorage.getItem("empId"),
      Status: form.getValues().Status,
      DoctypeId: form.getValues().DoctypeId,
    };
    const baseUrl = "/api/v1/TblDocument/get-list-export";
    const queryString = Object.entries(queryParams)
      .reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          const stringValue = value.toString();
          return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
        }
        return acc;
      }, "")
      .replace(/^&/, "");
    return `${baseUrl}${queryString ? `?${queryString}` : ""}`;
  }

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let _softing = "";
      if (sorting && sorting.length > 0) {
        let _q = sorting[0];
        if (_q) _softing = _q.id;
      }
      const queryParams = {
        Skip: pagination.pageIndex * pagination.pageSize,
        Take: pagination.pageSize,
        EmployeeId: form.getValues().EmployeeId,
        PartnerId: form.getValues().PartnerId,
        DepartmentId: form.getValues().DepartmentId,
        CustomerId: form.getValues().customerId,
        KeySearch:
          form.getValues().keySearch.toLowerCase() ||
          form.getValues().keySearch.toLowerCase(),
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        Status: form.getValues().Status,
        DoctypeId: form.getValues().DoctypeId,
      };
      const baseUrl = "/api/v1/TblDocument/get-list";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue = value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<DocumentRecord[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const VIEWED_ROWS_KEY = "folders_viewed_rows";
  function getViewedRows(): number[] {
    try {
      const data = localStorage.getItem(VIEWED_ROWS_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }
  function setViewedRows(ids: number[]) {
    localStorage.setItem(VIEWED_ROWS_KEY, JSON.stringify(ids));
  }

  const [viewedRows, setViewedRowsState] = useState<number[]>(getViewedRows());

  const handleRowClick = (row: any) => {
    const id = row.original.id;
    if (!id) return;
    // Chỉ giữ lại id vừa click, nếu đã chọn thì bỏ chọn hết
    let newViewed: number[] = viewedRows.includes(id) ? [] : [id];
    setViewedRowsState(newViewed);
    setViewedRows(newViewed);
  };

  const getRowStyle = (row: any) => {
    if (viewedRows.includes(row.original.id)) {
      return {
        ...styleTable,
        backgroundColor: "#ffc04c", // Màu nền highlight
        transition: "background-color 0.2s",
      };
    }
    return styleTable;
  };

  const handleDeleteTable = (ids: number) => {
    modals.openConfirmModal({
      title: <Title order={4}>Xóa hồ sơ</Title>,
      padding: "10px 10px 0",
      children: <DeleteTableView ids={ids} onSearch={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleEditTable = (ids: string | number) => {
    navigate("/method/folders-edit", {
      state: { id: ids },
    });
  };
  const handleViewTable = (ids: string | number) => {
    navigate("/method/view-page/2024" + ids);
  };
  const openModalCreate = () => navigate("/method/create-profile");

  const openModelHistory = (ids: number | null) =>
    modals.openConfirmModal({
      title: <Title order={4}>Lịch sử phê duyệt</Title>,
      size: "100%",
      children: <HistoryProfile ids={ids} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });

  // Add attachment modal handlers
  const handleOpenAttachmentModal = (
    documentId: number,
    attachments: string
  ) => {
    setSelectedDocumentForAttachment({ id: documentId, attachments });
    setAttachmentModalOpen(true);
  };

  const handleCloseAttachmentModal = () => {
    setAttachmentModalOpen(false);
    setSelectedDocumentForAttachment(null);
  };

  const handleAttachmentSaved = async () => {
    await fetchData(); // Refresh the table data
  };

  const { width } = useViewportSize();
  const isMobile = width < 768;
  const isTablet = width < 1024;

  // Debug logging to check viewport size

  const columns = React.useMemo<MRT_ColumnDef<DocumentRecord>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Mã hồ sơ",
        size: isMobile ? 150 : 200,
        Cell: ({ renderedCellValue, row }) => {
          return (
            <Badge
              radius="sm"
              variant="dot"
              tt="capitalize"
              color="green"
              fw={700}
              size={isMobile ? "md" : "lg"}
            >
              {renderedCellValue}
            </Badge>
          );
        },
      },
      {
        accessorKey: "name",
        header: "Tên hồ sơ",
      },
      {
        accessorKey: "doctypeName",
        header: "Loại hồ sơ",
      },
      {
        accessorKey: "createByName",
        header: "Người tạo",
        size: 170,
      },
      {
        accessorKey: "employeName",
        header: "Nhân viên",
        size: 170,
      },
      {
        accessorKey: "stepNumber",
        header: "Bước xử lý",
        enableSorting: false,
      },
      {
        accessorKey: "isSignature",
        header: "Trình ký",
        size: 150,

        Cell: ({ renderedCellValue, row }) => {
          return (
            <Badge
              variant="light"
              color={renderedCellValue === true ? "green" : "blue"}
            >
              {renderedCellValue === true ? "Đã trình ký" : "Chưa trình ký"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "isSuccess",
        header: "Trạng thái",
        enableSorting: false,
        size: 150,
        Cell: ({ renderedCellValue, row }) => {
          return (
            <Badge
              variant="light"
              color={
                renderedCellValue === true
                  ? "green"
                  : row.original.isIgore === true
                  ? "red"
                  : row.original.isSignature === true
                  ? "blue"
                  : "gray"
              }
            >
              {renderedCellValue === true
                ? "Đã duyệt"
                : row.original.isIgore === true
                ? "Không duyệt"
                : row.original.isSignature === true
                ? "Đang duyệt"
                : "Chờ yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "departmentName",
        header: "Đơn vị",
      },
      {
        accessorKey: "partnerName",
        header: "Đối tác",
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "startDate",
        header: "Ngày bắt đầu",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "expirationDate",
        header: "Ngày hết hiệu lực",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: isMobile ? 80 : 50,
        enableSorting: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? "5px" : "10px",
            }}
          >
            {isMobile ? (
              // Mobile view - Only show menu dropdown
              <Menu shadow="md" width={250} position="bottom-end">
                <Menu.Target>
                  <ActionIcon
                    color="blue"
                    variant="light"
                    aria-label="Actions"
                    size="lg"
                  >
                    <IconDotsVertical size={20} stroke={1.5} />
                  </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Label>Xem thông tin</Menu.Label>
                  <Menu.Item
                    leftSection={<IconEdit size={16} />}
                    onClick={async () => {
                      await handleViewTable(row.id);
                    }}
                  >
                    Xem file trình ký
                  </Menu.Item>

                  <Menu.Item
                    leftSection={<IconEye size={16} />}
                    onClick={() => {
                      if (row.original.id) {
                        const url = `/method/folders-details/${row.original.id}`;
                        window.open(url, "_blank");
                      } else {
                        NotificationExtension.Fails("Mã hồ sơ sai !");
                      }
                    }}
                  >
                    Xem hồ sơ
                  </Menu.Item>

                  <Menu.Item
                    leftSection={<IconMessageCircle size={16} />}
                    onClick={() => {
                      CommentModal({
                        documentId: row.original.id,
                      }).openModalComments();
                    }}
                  >
                    Xem comment
                  </Menu.Item>

                  <Menu.Divider />
                  <Menu.Label>Thao tác file</Menu.Label>
                  <Menu.Item
                    leftSection={<IconFileAnalytics size={16} />}
                    onClick={async () => {
                      if (row.original.signedDocument)
                        modals.openConfirmModal({
                          title: <Title order={4}>Xem file ký</Title>,
                          size: "95%",
                          children: (
                            <PdfFileView file={row.original.signedDocument} />
                          ),
                          confirmProps: { display: "none" },
                          cancelProps: { display: "none" },
                        });
                      else NotificationExtension.Fails("Hồ sơ chưa trình ký !");
                    }}
                  >
                    Xem file ký
                  </Menu.Item>
                  <Menu.Item
                    leftSection={<IconFileArrowRight size={16} />}
                    onClick={async () => {
                      if (row.original.attachments) {
                        modals.openConfirmModal({
                          title: <Title order={4}>Xem file đính kèm</Title>,
                          size: "95%",
                          children: (
                            <PdfFileView file={row.original.attachments} />
                          ),
                          confirmProps: { display: "none" },
                          cancelProps: { display: "none" },
                        });
                      } else {
                        NotificationExtension.Fails("Không có file đính kèm!");
                      }
                    }}
                    disabled={!row.original.attachments}
                  >
                    File đính kèm
                  </Menu.Item>

                  <Menu.Item
                    leftSection={<IconEdit size={16} />}
                    onClick={() => {
                      if (row.original.id) {
                        handleOpenAttachmentModal(
                          row.original.id,
                          row.original.attachments || ""
                        );
                      } else {
                        NotificationExtension.Fails("Mã hồ sơ không hợp lệ!");
                      }
                    }}
                  >
                    Sửa file đính kèm
                  </Menu.Item>

                  <Menu.Item
                    leftSection={<IconDownload size={16} />}
                    onClick={() =>
                      downloadFileWithLoading(
                        BASE_API_SIGN +
                          "/api/v1/signpage/get-files-documnet-v2?id=" +
                          row.original.id,
                        row.original.name +
                          "-" +
                          new Date().toISOString().slice(0, 10) +
                          ".zip"
                      )
                    }
                  >
                    Tải xuống
                  </Menu.Item>

                  <Menu.Divider />
                  <Menu.Label>Thao tác quy trình</Menu.Label>

                  {!row.original.isSignature === true && (
                    <Menu.Item
                      leftSection={<IconWritingSign size={16} />}
                      onClick={() => {
                        const _id = Number.parseInt(row.id);
                        if (_id < 1)
                          NotificationExtension.Fails(
                            "Mã hồ sơ không hợp lệ !"
                          );
                        else navigate(`/method/add-step/${_id}`);
                      }}
                    >
                      Trình ký
                    </Menu.Item>
                  )}

                  {(row.original.steupId ?? 0) > 0 && (
                    <Menu.Item
                      leftSection={<IconClock size={16} />}
                      onClick={() => {
                        if (row.original.steupId && row.original.steupId > 0)
                          openModelHistory(row.original.id);
                        else NotificationExtension.Info("Hồ sơ chưa trình ký!");
                      }}
                    >
                      Lịch sử
                    </Menu.Item>
                  )}

                  {row.original.isSignature === true &&
                    row.original.isIgore !== true && (
                      <Menu.Item
                        leftSection={<IconSend size={16} />}
                        onClick={async () => {
                          setIsLoading(true);
                          const url =
                            `/api/v1/SignPage/re-send-mail?stepSignId=` +
                            row.original.steupId;
                          const response = await repositorySign.get<
                            MessageResponse<boolean>
                          >(url);
                          if (response?.httpStatusCode === 200)
                            if (response && response.success) {
                              NotificationExtension.Success(
                                "Gửi mail thành công!"
                              );
                            } else
                              NotificationExtension.Info(
                                response.message?.length > 0
                                  ? response.message
                                  : "Thao tác xảy ra lỗi ở máy chủ !"
                              );
                          setIsLoading(false);
                        }}
                      >
                        Gửi lại mail
                      </Menu.Item>
                    )}

                  <Menu.Divider />
                  <Menu.Label>Quản lý</Menu.Label>

                  {/* {!row.original.isSignature === true && ( */}
                  <Menu.Item
                    leftSection={<IconEdit size={16} />}
                    onClick={async () => {
                      await handleEditTable(row.id);
                    }}
                  >
                    Chỉnh sửa
                  </Menu.Item>
                  {/* )} */}

                  <Menu.Item
                    leftSection={<IconTrash size={16} />}
                    color="red"
                    onClick={async () => {
                      await handleDeleteTable(row.original.id ?? 0);
                    }}
                  >
                    Xóa
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            ) : (
              // Desktop view - Show quick actions + menu
              <>
                <Tooltip label={"Xem hồ sơ"}>
                  <ActionIcon
                    onClick={async () => {
                      if (row.original.id) {
                        const url = `/method/folders-details/${row.original.id}`;
                        window.open(url, "_blank");
                      } else {
                        NotificationExtension.Fails("Mã hồ sơ sai !");
                      }
                    }}
                    color="pink.4"
                    variant="light"
                    aria-label="View Profile"
                  >
                    <IconEye size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
                <Tooltip label={"Xem file trình ký"}>
                  <ActionIcon
                    onClick={async () => {
                      if (row.original.id) {
                        navigate(`/method/view-page/${row.original.id}`);
                      } else NotificationExtension.Fails("Mã hồ sơ sai !");
                    }}
                    color="lime.4"
                    variant="light"
                    aria-label="View Profile"
                  >
                    <IconViewfinder size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
                <Tooltip label={"Xem comment"}>
                  <ActionIcon
                    onClick={() => {
                      CommentModal({
                        documentId: row.original.id,
                      }).openModalComments();
                    }}
                    color="orange"
                    variant="light"
                    aria-label="View Comments"
                  >
                    <IconMessageCircle size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>

                {/* More Actions Menu */}
                <Menu shadow="md" width={200}>
                  <Menu.Target>
                    <ActionIcon
                      color="gray"
                      variant="light"
                      aria-label="More Actions"
                    >
                      <IconDotsVertical size={20} stroke={1.5} />
                    </ActionIcon>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Label>Thao tác file</Menu.Label>
                    <Menu.Item
                      leftSection={<IconFileAnalytics size={16} />}
                      onClick={async () => {
                        if (row.original.signedDocument)
                          modals.openConfirmModal({
                            title: <Title order={4}>Xem file ký</Title>,
                            size: "80%",
                            children: (
                              <PdfFileView file={row.original.signedDocument} />
                            ),
                            confirmProps: { display: "none" },
                            cancelProps: { display: "none" },
                          });
                        else
                          NotificationExtension.Fails("Hồ sơ chưa trình ký !");
                      }}
                    >
                      Xem file ký
                    </Menu.Item>

                    <Menu.Item
                      leftSection={<IconFileArrowRight size={16} />}
                      onClick={async () => {
                        if (row.original.attachments) {
                          modals.openConfirmModal({
                            title: <Title order={4}>Xem file đính kèm</Title>,
                            size: "80%",
                            children: (
                              <PdfFileView file={row.original.attachments} />
                            ),
                            confirmProps: { display: "none" },
                            cancelProps: { display: "none" },
                          });
                        } else {
                          NotificationExtension.Fails(
                            "Không có file đính kèm!"
                          );
                        }
                      }}
                      disabled={!row.original.attachments}
                    >
                      File đính kèm
                    </Menu.Item>

                    <Menu.Item
                      leftSection={<IconEdit size={16} />}
                      onClick={() => {
                        if (row.original.id) {
                          handleOpenAttachmentModal(
                            row.original.id,
                            row.original.attachments || ""
                          );
                        } else {
                          NotificationExtension.Fails("Mã hồ sơ không hợp lệ!");
                        }
                      }}
                    >
                      Sửa file đính kèm
                    </Menu.Item>

                    <Menu.Item
                      leftSection={<IconDownload size={16} />}
                      onClick={() =>
                        downloadFileWithLoading(
                          BASE_API_SIGN +
                            "/api/v1/signpage/get-files-documnet-v2?id=" +
                            row.original.id,
                          row.original.name +
                            "-" +
                            new Date().toISOString().slice(0, 10) +
                            ".zip"
                        )
                      }
                    >
                      Tải xuống
                    </Menu.Item>

                    <Menu.Divider />
                    <Menu.Label>Thao tác quy trình</Menu.Label>

                    {!row.original.isSignature === true && (
                      <Menu.Item
                        leftSection={<IconWritingSign size={16} />}
                        onClick={() => {
                          const _id = Number.parseInt(row.id);
                          if (_id < 1)
                            NotificationExtension.Fails(
                              "Mã hồ sơ không hợp lệ !"
                            );
                          else navigate(`/method/add-step/${_id}`);
                        }}
                      >
                        Trình ký
                      </Menu.Item>
                    )}

                    {(row.original.steupId ?? 0) > 0 && (
                      <Menu.Item
                        leftSection={<IconClock size={16} />}
                        onClick={() => {
                          if (row.original.steupId && row.original.steupId > 0)
                            openModelHistory(row.original.id);
                          else
                            NotificationExtension.Info("Hồ sơ chưa trình ký!");
                        }}
                      >
                        Lịch sử
                      </Menu.Item>
                    )}

                    {row.original.isSignature === true &&
                      row.original.isIgore !== true && (
                        <Menu.Item
                          leftSection={<IconSend size={16} />}
                          onClick={async () => {
                            setIsLoading(true);
                            const url =
                              `/api/v1/SignPage/re-send-mail?stepSignId=` +
                              row.original.steupId;
                            const response = await repositorySign.get<
                              MessageResponse<boolean>
                            >(url);
                            if (response?.httpStatusCode === 200)
                              if (response && response.success) {
                                NotificationExtension.Success(
                                  "Gửi mail thành công!"
                                );
                              } else
                                NotificationExtension.Info(
                                  response.message?.length > 0
                                    ? response.message
                                    : "Thao tác xảy ra lỗi ở máy chủ !"
                                );
                            setIsLoading(false);
                          }}
                        >
                          Gửi lại mail
                        </Menu.Item>
                      )}

                    <Menu.Divider />
                    <Menu.Label>Quản lý</Menu.Label>

                    {/* {!row.original.isSignature === true && ( */}
                    <Menu.Item
                      leftSection={<IconEdit size={16} />}
                      onClick={async () => {
                        await handleEditTable(row.id);
                      }}
                    >
                      Chỉnh sửa
                    </Menu.Item>
                    {/* )} */}

                    <Menu.Item
                      leftSection={<IconTrash size={16} />}
                      color="red"
                      onClick={async () => {
                        await handleDeleteTable(row.original.id ?? 0);
                      }}
                    >
                      Xóa
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </>
            )}
          </Box>
        ),
      },
    ],
    [listVendor, dataFetch, listEmployee, listDocType, isMobile]
  );

  //API gọi danh sách nhân viên
  useEffect(() => {
    const fetchInitialData = async () => {
      // 1) Khôi phục bộ lọc trước để danh sách chính tải NGAY,
      //    không phải đợi các API select dropdown chạy xong.
      const urlKeySearch = searchParams.get("code") ?? "";
      if (urlKeySearch) {
        form.setFieldValue("keySearch", urlKeySearch);
      } else {
        const savedCriteria = getSearchCriteria();
        if (savedCriteria) {
          Object.entries(savedCriteria).forEach(([key, value]) => {
            if (value && value.toString().trim() !== "") {
              form.setFieldValue(key as keyof typeof search, value);
            }
          });
        }
      }
      setIsInitialized(true);

      // 2) Tải các select song song (Promise.all), chạy nền — chỉ để đổ
      //    dropdown lọc, không chặn danh sách chính.
      try {
        const [
          responseDocType,
          _user,
          responseDepartment,
          responseVendor,
          responseDocument,
        ] = await Promise.all([
          repositorySign.get<MessageResponse<SelectListItem[]>>(
            "/api/v1/TblDocType/get-select"
          ),
          getUsersSelect(),
          repositorySign.get<MessageResponse<any>>(
            "/api/v1/Department/get-select"
          ),
          repositorySign.get<MessageResponse<SelectListItem[]>>(
            "/api/v1/TblVendor/get-select"
          ),
          repositorySign.get<MessageResponse<SelectListItem[]>>(
            "/api/v1/TblDocument/get-select"
          ),
        ]);

        if (responseDocType && responseDocType.success)
          setListDocType(responseDocType.data);
        if (_user) setListEmployee(_user);
        if (responseDepartment && responseDepartment.success)
          setDataFetch(responseDepartment.data);
        if (responseVendor && responseVendor.success)
          setListVendor(responseVendor.data);
        if (responseDocument && responseDocument.success)
          setListDocument(responseDocument.data);
      } catch (error) {
        // Lỗi dropdown không ảnh hưởng danh sách chính
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    // Only call fetchData after initialization is complete
    if (isInitialized) {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, sorting, isInitialized]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable<DocumentRecord>({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    localization: _localization,
    enableRowSelection: true,
    enableTopToolbar: false,
    getRowId: (row) => row?.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: isMobile
        ? {}
        : {
            left: ["mrt-row-select", "code"],
            right: ["action"],
          },
      columnVisibility: {
        id: false,
        // Hide less important columns on mobile
        ...(isMobile && {
          departmentName: false,
          partnerName: false,
          startDate: false,
          expirationDate: false,
          stepNumber: false,
        }),
      },
      density: isMobile ? "md" : "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: () => handleRowClick(row),
      style: getRowStyle(row),
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
      columnPinning: isMobile
        ? {}
        : {
            left: ["mrt-row-select", "code"],
            right: ["action"],
          },
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: !isMobile,
    mantineTableProps: {
      striped: false,
    },
  });

  //#endregion
  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: isMobile ? "8px" : "10px",
        }}
        ref={headerRef}
      >
        <Flex
          justify="space-between"
          align={isMobile ? "flex-start" : "center"}
          direction={isMobile ? "column" : "row"}
          gap={isMobile ? "sm" : "md"}
        >
          <BreadcrumbLayout1 />
          <Flex
            gap={isMobile ? "xs" : "md"}
            align="center"
            direction={isMobile ? "column" : "row"}
            wrap="wrap"
            w={isMobile ? "100%" : "auto"}
          >
            {isMobile && (
              <Button
                leftSection={<IconFilter size={14} />}
                color="orange"
                variant={filterOpen ? "filled" : "outline"}
                onClick={() => setFilterOpen(!filterOpen)}
                size="sm"
                fullWidth
              >
                {filterOpen ? "Ẩn bộ lọc" : "Bộ lọc"}
              </Button>
            )}

            {isMobile ? (
              // Mobile: Group Thêm mới and Export Excel in one row
              <Flex gap="xs" w="100%">
                <Button
                  leftSection={<IconPlus size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={openModalCreate}
                  size="sm"
                  style={{ flex: 1 }}
                >
                  Thêm mới
                </Button>
                <Button
                  leftSection={<IconDownload size={14} />}
                  color="violet"
                  variant="outline"
                  component="a"
                  href={BASE_API_SIGN + getUrlSearchExport()}
                  download
                  size="sm"
                  style={{ flex: 1 }}
                >
                  Export Excel
                </Button>
              </Flex>
            ) : (
              // Desktop: Keep separate buttons
              <>
                <Button
                  leftSection={<IconPlus size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={openModalCreate}
                  size="sm"
                >
                  Thêm mới
                </Button>
                <Button
                  leftSection={<IconDownload size={14} />}
                  color="violet"
                  variant="outline"
                  component="a"
                  href={BASE_API_SIGN + getUrlSearchExport()}
                  download
                  size="sm"
                >
                  Export Excel
                </Button>
              </>
            )}

            {/* <Button
              color="red"
              variant="outline"
              leftSection={<IconTrash size={14} />}
              onClick={async () => {
                await handleDeleteTable(selectIds as number[]);
              }}
              disabled={selectIds.length < 1}
              size={isMobile ? "sm" : "sm"}
              fullWidth={isMobile}
            >
              Xóa
            </Button> */}
          </Flex>
        </Flex>

        {isMobile ? (
          // Mobile: Collapsible filter
          <Collapse in={filterOpen}>
            <form
              style={{
                marginTop: "12px",
                paddingTop: "12px",
                borderTop: "1px solid #e9ecef",
              }}
            >
              <Grid gutter="xs">
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <TextInput
                    label="Từ khóa"
                    leftSection={<IconSearch color="#15aabf" size={16} />}
                    placeholder="Nhập từ khóa"
                    key={form.key(`keySearch`)}
                    {...form.getInputProps("keySearch")}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    label="Nhân viên"
                    leftSection={<IconUsers color="#15aabf" size={16} />}
                    placeholder="Chọn nhân viên"
                    data={listEmployee.map((employee) => ({
                      value: employee.value ?? "",
                      label: employee.text,
                    }))}
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    key={form.key(`EmployeeId`)}
                    {...form.getInputProps("EmployeeId")}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    label="Đối tác"
                    key={form.key(`PartnerId`)}
                    leftSection={<IconUsersGroup color="#15aabf" size={16} />}
                    placeholder="Chọn đối tác"
                    data={listVendor.map((employee) => ({
                      value: employee.value,
                      label: employee.text,
                    }))}
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    {...form.getInputProps("PartnerId")}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    key={form.key(`DoctypeId`)}
                    label="Hồ sơ"
                    leftSection={<IconFile color="#15aabf" size={16} />}
                    placeholder="Chọn hồ sơ"
                    data={listDocType.map((employee) => ({
                      value: employee.value,
                      label: employee.text,
                    }))}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    {...form.getInputProps("DoctypeId")}
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    label="Đơn vị"
                    leftSection={<IconPencilUp color="#15aabf" size={16} />}
                    placeholder="Chọn đơn vị"
                    data={dataFetch.map((employee) => ({
                      value: employee.value,
                      label: employee.text,
                    }))}
                    limit={20}
                    comboboxProps={{
                      transitionProps: { transition: "pop", duration: 200 },
                    }}
                    key={form.key(`DepartmentId`)}
                    {...form.getInputProps("DepartmentId")}
                    nothingFoundMessage="Không có dữ liệu"
                    searchable
                    clearable
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Select
                    key={form.key(`Status`)}
                    id="status"
                    clearable
                    label="Trạng thái"
                    leftSection={<IconBrandRedux color="#15aabf" size={16} />}
                    placeholder="Chọn trạng thái"
                    data={[
                      { value: "1", label: "Chờ yêu cầu" },
                      { value: "2", label: "Đang duyệt" },
                      { value: "3", label: "Đã duyệt" },
                      { value: "4", label: "Không duyệt" },
                    ]}
                    {...form.getInputProps("Status")}
                    nothingFoundMessage="Không có dữ liệu"
                    size="sm"
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                  <Flex gap="xs" style={{ paddingTop: "25px" }}>
                    <Button
                      leftSection={<IconSearch size={14} />}
                      color="blue"
                      variant="outline"
                      onClick={handleSearch}
                      size="sm"
                      style={{ flex: 1 }}
                    >
                      Tìm kiếm
                    </Button>
                    <Button
                      variant="subtle"
                      color="gray"
                      onClick={handleClearSearch}
                      size="sm"
                    >
                      Xóa
                    </Button>
                  </Flex>
                </Grid.Col>
              </Grid>
            </form>
          </Collapse>
        ) : (
          // Desktop: Original filter layout
          <form style={{ marginTop: "16px" }}>
            <Grid>
              <Grid.Col span={_span}>
                <TextInput
                  label="Từ khóa"
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  label="Nhân viên"
                  leftSection={<IconUsers color="#15aabf" />}
                  placeholder="Chọn nhân viên trình ký"
                  data={listEmployee.map((employee) => ({
                    value: employee.value ?? "",
                    label: employee.text,
                  }))}
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  key={form.key(`EmployeeId`)}
                  {...form.getInputProps("EmployeeId")}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  label="Đối tác"
                  key={form.key(`PartnerId`)}
                  leftSection={<IconUsersGroup color="#15aabf" />}
                  placeholder="Chọn đối tác"
                  data={listVendor.map((employee) => ({
                    value: employee.value,
                    label: employee.text,
                  }))}
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  {...form.getInputProps("PartnerId")}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  key={form.key(`DoctypeId`)}
                  label="Hồ sơ"
                  leftSection={<IconFile color="#15aabf" />}
                  placeholder="Chọn hồ sơ"
                  data={listDocType.map((employee) => ({
                    value: employee.value,
                    label: employee.text,
                  }))}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  {...form.getInputProps("DoctypeId")}
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  label="Đơn vị"
                  leftSection={<IconPencilUp color="#15aabf" />}
                  placeholder="Chọn đơn vị trình ký"
                  data={dataFetch.map((employee) => ({
                    value: employee.value,
                    label: employee.text,
                  }))}
                  limit={20}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  key={form.key(`DepartmentId`)}
                  {...form.getInputProps("DepartmentId")}
                  nothingFoundMessage="Không có dữ liệu"
                  searchable
                  clearable
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Select
                  key={form.key(`Status`)}
                  id="status"
                  clearable
                  label="Trạng thái"
                  leftSection={<IconBrandRedux color="#15aabf" />}
                  placeholder="Chọn trạng thái"
                  data={[
                    { value: "1", label: "Chờ yêu cầu" },
                    { value: "2", label: "Đang duyệt" },
                    { value: "3", label: "Đã duyệt" },
                    { value: "4", label: "Không duyệt" },
                  ]}
                  {...form.getInputProps("Status")}
                  nothingFoundMessage="Không có dữ liệu"
                />
              </Grid.Col>
              <Grid.Col span={_span}>
                <Flex gap="xs" align="flex-end">
                  <Button
                    leftSection={<IconSearch size={14} />}
                    color="blue"
                    variant="outline"
                    onClick={handleSearch}
                  >
                    Tìm kiếm
                  </Button>
                  <Button
                    variant="subtle"
                    color="gray"
                    onClick={handleClearSearch}
                  >
                    Xóa
                  </Button>
                </Flex>
              </Grid.Col>
            </Grid>
          </form>
        )}
      </div>
      <div style={{ overflowX: isMobile ? "auto" : "unset" }}>
        <MantineReactTable table={table} />
      </div>

      {/* Attachment Edit Modal */}
      {selectedDocumentForAttachment && (
        <AttachmentEditModal
          opened={attachmentModalOpen}
          onClose={handleCloseAttachmentModal}
          documentId={selectedDocumentForAttachment.id}
          currentAttachments={selectedDocumentForAttachment.attachments}
          onSave={handleAttachmentSaved}
        />
      )}
    </>
  );
};

export default FoldersTable;
